import { render } from "./EmailIndex.vue?vue&type=template&id=5b8d47ea&scoped=true"
import script from "./EmailIndex.vue?vue&type=script&lang=js"
export * from "./EmailIndex.vue?vue&type=script&lang=js"

import "./EmailIndex.vue?vue&type=style&index=0&id=5b8d47ea&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5b8d47ea"

export default script